// extracted by mini-css-extract-plugin
export default {"row":"viewEvent_row__5yztV","col":"viewEvent_col__0uDuf","card":"viewEvent_card__NRmig"};